import { rectToClientRect as $ } from "../../core/dist/floating-ui.core.esm.js";
function f(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function D(t) {
  return f(t).getComputedStyle(t);
}
function F(t) {
  return t instanceof f(t).Node;
}
function V(t) {
  return F(t) ? (t.nodeName || "").toLowerCase() : "";
}
let b;
function H() {
  if (b)
    return b;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (b = t.brands.map((e) => e.brand + "/" + e.version).join(" "), b) : navigator.userAgent;
}
function A(t) {
  return t instanceof f(t).HTMLElement;
}
function v(t) {
  return t instanceof f(t).Element;
}
function N(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  const e = f(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function B(t) {
  const {
    overflow: e,
    overflowX: o,
    overflowY: n,
    display: l
  } = D(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + o) && !["inline", "contents"].includes(l);
}
function W() {
  return /^((?!chrome|android).)*safari/i.test(H());
}
function k(t) {
  return ["html", "body", "#document"].includes(V(t));
}
const x = Math.round;
function M(t) {
  const e = D(t);
  let o = parseFloat(e.width), n = parseFloat(e.height);
  const l = A(t), r = l ? t.offsetWidth : o, s = l ? t.offsetHeight : n, i = x(o) !== r || x(n) !== s;
  return i && (o = r, n = s), {
    width: o,
    height: n,
    fallback: i
  };
}
function O(t) {
  return v(t) ? t : t.contextElement;
}
const T = {
  x: 1,
  y: 1
};
function L(t) {
  const e = O(t);
  if (!A(e))
    return T;
  const o = e.getBoundingClientRect(), {
    width: n,
    height: l,
    fallback: r
  } = M(e);
  let s = (r ? x(o.width) : o.width) / n, i = (r ? x(o.height) : o.height) / l;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
function S(t, e, o, n) {
  var l, r;
  e === void 0 && (e = !1), o === void 0 && (o = !1);
  const s = t.getBoundingClientRect(), i = O(t);
  let u = T;
  e && (n ? v(n) && (u = L(n)) : u = L(t));
  const g = i ? f(i) : window, d = W() && o;
  let w = (s.left + (d && ((l = g.visualViewport) == null ? void 0 : l.offsetLeft) || 0)) / u.x, a = (s.top + (d && ((r = g.visualViewport) == null ? void 0 : r.offsetTop) || 0)) / u.y, E = s.width / u.x, c = s.height / u.y;
  if (i) {
    const p = f(i), z = n && v(n) ? f(n) : n;
    let m = p.frameElement;
    for (; m && n && z !== p; ) {
      const h = L(m), y = m.getBoundingClientRect(), C = getComputedStyle(m);
      y.x += (m.clientLeft + parseFloat(C.paddingLeft)) * h.x, y.y += (m.clientTop + parseFloat(C.paddingTop)) * h.y, w *= h.x, a *= h.y, E *= h.x, c *= h.y, w += y.x, a += y.y, m = f(m).frameElement;
    }
  }
  return $({
    width: E,
    height: c,
    x: w,
    y: a
  });
}
function I(t) {
  return ((F(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function U(t) {
  if (V(t) === "html")
    return t;
  const e = t.assignedSlot || t.parentNode || N(t) && t.host || I(t);
  return N(e) ? e.host : e;
}
function _(t) {
  const e = U(t);
  return k(e) ? e.ownerDocument.body : A(e) && B(e) ? e : _(e);
}
function R(t, e) {
  var o;
  e === void 0 && (e = []);
  const n = _(t), l = n === ((o = t.ownerDocument) == null ? void 0 : o.body), r = f(n);
  return l ? e.concat(r, r.visualViewport || [], B(n) ? n : []) : e.concat(n, R(n));
}
function q(t, e, o, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: l = !0,
    ancestorResize: r = !0,
    elementResize: s = !0,
    animationFrame: i = !1
  } = n, u = l && !i, g = u || r ? [...v(t) ? R(t) : t.contextElement ? R(t.contextElement) : [], ...R(e)] : [];
  g.forEach((c) => {
    u && c.addEventListener("scroll", o, {
      passive: !0
    }), r && c.addEventListener("resize", o);
  });
  let d = null;
  s && (d = new ResizeObserver(() => {
    o();
  }), v(t) && !i && d.observe(t), !v(t) && t.contextElement && !i && d.observe(t.contextElement), d.observe(e));
  let w, a = i ? S(t) : null;
  i && E();
  function E() {
    const c = S(t);
    a && (c.x !== a.x || c.y !== a.y || c.width !== a.width || c.height !== a.height) && o(), a = c, w = requestAnimationFrame(E);
  }
  return o(), () => {
    var c;
    g.forEach((p) => {
      u && p.removeEventListener("scroll", o), r && p.removeEventListener("resize", o);
    }), (c = d) == null || c.disconnect(), d = null, i && cancelAnimationFrame(w);
  };
}
export {
  q as autoUpdate,
  R as getOverflowAncestors
};
//# sourceMappingURL=floating-ui.dom.esm.js.map
